import { useMemo } from 'react';

import dayjs, { Dayjs } from 'dayjs';
import { useSearchParams } from 'react-router-dom';

import { queryParameters } from '~constants';

const searchParamDateFormat = 'YYYYMMDD';

// TODO: generic typing for dayjs and date
// <T extends Dayjs | Date>
const useUrlSearchParamsDate = (
	defaultDate: Dayjs | undefined = dayjs(),
	type: 'date' = 'date'
): [Dayjs, (value: Dayjs) => void] => {
	const [searchParams, setSearchParams] = useSearchParams();

	const date = useMemo(() => {
		const dateSearchParam = searchParams.get(queryParameters.Date);

		/**
		 * Try to parse the date from a string
		 * @param dateString
		 * @returns
		 */
		const parseDate = (dateString: string) => {
			let date = dayjs(dateString, searchParamDateFormat);
			if (!date.isValid()) {
				date = dayjs(dateString);
			}

			if (!date.isValid() || date == null) {
				return defaultDate;
			}

			return date;
		};

		if (dateSearchParam != null) {
			return parseDate(dateSearchParam);
		}

		return defaultDate;
	}, [searchParams, defaultDate]);

	const setDate = (value?: Dayjs) => {
		setSearchParams((prev) => {
			if (!value) {
				prev.delete(queryParameters.Date);
			} else if (type === 'date') {
				const dateString = value.format(searchParamDateFormat);

				prev.set(queryParameters.Date, dateString);
			}
			return prev;
		});
	};

	return [date, setDate];
};

export default useUrlSearchParamsDate;
